import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { IntroductionButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import { useDisclosure } from '@hooks/useDisclosure';

import { useImpactsOnStakeholdersForm } from '../ImpactsOnStakeholdersFormProvider';
import { IImpactsOnStakeholdersFormValues } from '../ImpactsOnStakeholdersFormProvider/types';

export const IMPACT_STAKEHOLDER_INTRODUCTION_ID = 'impact-stk-introduction';

const ImpactsOnStakeholderOverviewIntroduction = () => {
  const { control, getValues } = useImpactsOnStakeholdersForm();
  const introduction = getValues(
    `introduction`
  ) as IImpactsOnStakeholdersFormValues['introduction'];

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!introduction);

  const introductionEl = document.getElementById(
    IMPACT_STAKEHOLDER_INTRODUCTION_ID
  );

  const [isAllCompletedTh, isAllCompletedEn] = useWatch({
    name: ['completedSection.isCompletedTh', 'completedSection.isCompletedEn'],
    control,
  });

  return (
    <>
      <IntroductionButton
        onClick={open}
        disabled={isAllCompletedTh && isAllCompletedEn}
      />
      {isIntroductionOpen &&
        introductionEl &&
        createPortal(
          <Box mt={2}>
            <Introduction
              onDelete={close}
              topic="การจัดการผลกระทบต่อผู้มีส่วนได้เสียในห่วงโซ่คุณค่าของธุรกิจ"
              setOpen={open}
              fieldPath="introduction"
              isCompletedEn={isAllCompletedEn}
              isCompletedTh={isAllCompletedTh}
            />
          </Box>,
          introductionEl
        )}
    </>
  );
};

export default ImpactsOnStakeholderOverviewIntroduction;
